import React from 'react';
import { Card, Container, Row, Col, Image } from 'react-bootstrap';
import { FaLinkedin } from "react-icons/fa";


const courses = [
    {
        title: 'Introducción',
        description: 'Bienvenida al VML Academy. Ven a conocer más sobre VML y el mundo de la publicidad.',
        image: '/images/programa1.png',
        startDate: '01/08/2025',
        category: 'Bienvenida',
        teachers: [
            {
                name: 'Paul Thorndike',
                job: 'Chief Executive Officer',
                linkedin: 'https://www.linkedin.com/in/thorndikepaul/',
                image: '/images/personas/paul_thorndike.jpeg'
            },
            {
                name: 'Eduardo Grisolle',
                job: 'Chief Executive Officer',
                linkedin: 'https://www.linkedin.com/in/eduardogrisolle/',
                image: '/images/personas/eduardo_grisolle.jpeg'
            }
        ]
    },
    {
        title: 'IA como segundo cerebro',
        description: 'Conoce cómo se utiliza la Inteligencia Artificial en publicidad.',
        image: '/images/programa2.png',
        startDate: '01/08/2025',
        category: 'IA',
        teachers: [
            {
                name: 'Sebastián Carrillo',
                job: 'Performance Lead',
                linkedin: 'https://www.linkedin.com/in/sebastian-carrillo-brake-a62b37145/',
                image: '/images/personas/sebastian_carrillo.jpeg'
            }
        ]
    },
    {
        title: 'Creando el Brief del Mañana',
        description: 'Cultura y Social Media, descubre más sobre las tendencias y las redes sociales.',
        image: '/images/programa1.png',
        startDate: '01/08/2025',
        category: 'Social Media',
        teachers: [
            {
                name: 'Nicolás Rodriguez',
                job: 'Director de Innovación',
                linkedin: 'https://www.linkedin.com/in/nicolasrodriguezz/',
                image: '/images/personas/nicolas_rodriguez.jpeg'
            }
        ]
    },
    {
        title: 'Diseñando el Futuro de Marcas Conectadas',
        description: 'Descubre cómo nacen las grandes ideas estratégicas en una agencia de publicidad.',
        image: '/images/programa2.png',
        startDate: '01/08/2025',
        category: 'Planning',
        teachers: [
            {
                name: 'Angélica Revilla',
                job: 'Planning Director',
                linkedin: 'https://www.linkedin.com/in/ang%C3%A9lica-revilla-89164828/',
                image: '/images/personas/angelica_revilla.jpeg'
            }
        ]
    },
    {
        title: 'Unos ven, otros observamos',
        description: 'El inicio de una idea está frente a ti, deja de verla y empieza a observarla.',
        image: '/images/programa1.png',
        startDate: '01/08/2025',
        category: 'Creatividad',
        teachers: [
            {
                name: 'Diego Figueroa (Tiito)',
                job: 'Creative Director',
                linkedin: 'https://www.linkedin.com/in/diegofigueroas/',
                image: '/images/personas/diego_figueroa.jpeg'
            }
        ]
    },
    {
        title: 'Juguemos en Primera: Dirección de Arte Dentro de la Cancha',
        description: 'Descubre más acerca de la Dirección de Arte en agencias de publicidad.',
        image: '/images/programa2.png',
        startDate: '01/08/2025',
        category: 'Arte y diseño',
        teachers: [
            {
                name: 'Edher Espinoza (Tibu)',
                job: 'Creative Arte Director',
                linkedin: 'https://www.linkedin.com/in/tibu-espinoza-villacrez-54b11b57/',
                image: '/images/personas/edher_espinoza.jpeg'
            }
        ]
    },
];


const Courses = () => {

    return (
        <Container id="programas" className={`fade-in`}>
            <h1>Programa</h1>
            <Row>
                {courses.map((course, index) => (
                    <Col lg={4} md={6} sm={12} key={index} className="mb-4">
                        <Card className='programa'>
                            <div style={{ position: "relative" }}>
                                <Card.Img
                                    variant="top"
                                    src={course.image}
                                    alt={course.title}
                                    className='programa-image'
                                />
                                <div
                                    className='programa-category'
                                >
                                    {course.category}
                                </div>
                            </div>
                            <Card.Body className='programa-body'>
                                <div>
                                    <Card.Title>
                                        <h5>{course.title}</h5>
                                    </Card.Title>
                                    <Card.Text>{course.description}</Card.Text>
                                </div>
                                <div className="mt-auto">
                                    <div className="mb-2">
                                        <strong>Fecha de inicio:</strong> {course.startDate}
                                    </div>
                                    <div className="mb-3">
                                        <strong>Imparte:</strong>
                                        <div className="imparte">
                                            {course.teachers.map((teacher, teacherIndex) => (
                                                <div key={teacherIndex} className="me-3 mb-2 mt-2 text-center" style={{ minWidth: "100px" }}>
                                                    <Image
                                                        src={teacher.image || "/placeholder.svg"}
                                                        alt={teacher.name}
                                                        roundedCircle
                                                        className='imparte-image'
                                                    />
                                                    <div className='imparte-name'>
                                                        {teacher.name}
                                                    </div>
                                                    <div
                                                        className='imparte-job'
                                                    >
                                                        {teacher.job}
                                                        {teacher.linkedin && (
                                                            <a 
                                                                href={teacher.linkedin} 
                                                                target="_blank" 
                                                                rel="noopener noreferrer"
                                                                className="linkedin-icon" // We'll add a class for styling
                                                            >
                                                                <FaLinkedin />
                                                            </a>
                                                        )}                                                        
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default Courses;
